"use client";

import { c as _c } from "react/compiler-runtime";
import { BylineAuthorImage } from "@/components/ArticleContent/components/Byline/components/BylineAuthorImage/BylineAuthorImage.component";
import { useAuthorHover } from "@/components/ArticleContent/components/Byline/context/byline-context";
import { getAuthorImageZIndex, getHoveredTransform } from "@/components/ArticleContent/components/Byline/utilities/byline-utils";
import type { ArticleContentModel } from "@/services/api/content/models/article-content-model.types";
type AuthorImagesProps = {
  readonly authors: ReadonlyArray<ArticleContentModel.Author>;
  readonly model: ArticleContentModel.Byline;
};
export function AuthorImages(t0) {
  const $ = _c(9);
  const {
    model,
    authors
  } = t0;
  const {
    hoveredAuthorIndex
  } = useAuthorHover();
  let t1;
  if ($[0] !== authors || $[1] !== hoveredAuthorIndex || $[2] !== model) {
    let t2;
    if ($[4] !== hoveredAuthorIndex || $[5] !== model) {
      t2 = (author, index) => {
        const isHovered = hoveredAuthorIndex === index;
        return <div className="relative size-6 transition-all duration-300 ease-out first:ml-0" key={author.email || author.fullName} style={{
          transform: getHoveredTransform(isHovered),
          zIndex: getAuthorImageZIndex(model, hoveredAuthorIndex, index)
        }}><BylineAuthorImage author={author} authorIndex={index} isHovered={isHovered} /></div>;
      };
      $[4] = hoveredAuthorIndex;
      $[5] = model;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = authors.map(t2);
    $[0] = authors;
    $[1] = hoveredAuthorIndex;
    $[2] = model;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="relative flex flex-shrink-0 -space-x-1.25">{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}